<div class="physical-person-form" *ngIf="personType === 'FISICA'">
    <div class="form-line">
        <div class="document-field-container">
            <mat-form-field class="garantor-form-field document-type-select" appearance="outline">
                <mat-label>Tipo</mat-label>
                <mat-select [formControl]="formGroup.controls.tipoDocumento">
                    <mat-option value="DNI">DNI</mat-option>
                    <mat-option value="PASAPORTE">Pasaporte</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="garantor-form-field dni-pasaporte-field" appearance="outline"
                *ngIf="formGroup.controls.tipoDocumento?.value === 'DNI'">
                <mat-label>DNI</mat-label>
                <input matInput [formControl]="formGroup.controls.dni">
                <mat-error *ngIf="formGroup.controls.dni.hasError('required')">
                    Por favor ingrese un dni
                </mat-error>
                <mat-error *ngIf="formGroup.controls.dni.hasError('minlength') || formGroup.controls.dni.hasError('maxlength')">
                    El dni debe tener 8 dígitos
                </mat-error>
                <mat-error *ngIf="formGroup.controls.dni.hasError('number')">
                    El dni debe ser un número
                </mat-error>
                <mat-hint>Ejemplo: 12345678</mat-hint>
            </mat-form-field>

            <mat-form-field class="garantor-form-field dni-pasaporte-field" appearance="outline"
                *ngIf="formGroup.controls.tipoDocumento?.value === 'PASAPORTE'">
                <mat-label>Pasaporte</mat-label>
                <input matInput [formControl]="formGroup.controls.pasaporte">
                <mat-error *ngIf="formGroup.controls.pasaporte.hasError('required')">
                    Por favor ingrese un pasaporte
                </mat-error>
                <mat-error *ngIf="formGroup.controls.pasaporte.hasError('minlength')">
                    El pasaporte debe tener al menos 6 caracteres
                </mat-error>
                <mat-hint>Ejemplo: ABC123456</mat-hint>
            </mat-form-field>
        </div>
        
        <app-sex-selector class="sex-selector-container" [formControl]="formGroup.controls.sexo"></app-sex-selector>
    </div>
    <ng-content></ng-content>
    <div class="form-line">
        <mat-form-field class="garantor-form-field nombre" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput [formControl]="formGroup.controls.nombre">
            <mat-error *ngIf="formGroup.controls.nombre.hasError('required')">
                Por favor ingrese un nombre
            </mat-error>
        </mat-form-field>
        <mat-form-field class="garantor-form-field apellido" appearance="outline">
            <mat-label>Apellido</mat-label>
            <input matInput [formControl]="formGroup.controls.apellido">
            <mat-error *ngIf="formGroup.controls.apellido.hasError('required')">
                Por favor ingrese un apellido
            </mat-error>
        </mat-form-field>
    </div>
    <div class="form-line">
        <mat-form-field class="garantor-form-field telefono" appearance="outline">
            <mat-label>Teléfono</mat-label>
            <app-phone-input [formControl]="formGroup.controls.celular"></app-phone-input>
            <mat-error *ngIf="formGroup.controls.celular.hasError('required')">
                Por favor ingrese un teléfono
            </mat-error>
            <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
        </mat-form-field>
        <mat-form-field class="garantor-form-field fecha-nacimiento" appearance="outline">
            <mat-label>Fecha de nacimiento</mat-label>
            <input matInput [formControl]="formGroup.controls.fechaNacimiento" [matDatepicker]="picker1">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="formGroup.controls.fechaNacimiento.hasError('required')">
                Por favor ingrese una fecha
            </mat-error>
        </mat-form-field>
    </div>
</div>
